<script>
import {onMounted, ref,computed} from 'vue'
import { useStore, mapGetters } from 'vuex'
import MenuMain from './menu/menu.vue';
import { tableHeight } from "@/tools/lines.js";
import {useMyInnerHeight}from "@/mixin/page.js";
export default {
    name: 'layout-base-left',
    components: { MenuMain },
    computed:{
        ...mapGetters('page', ['getBaseMenu'])
    },
    setup(){
      const {innerHeight} = useMyInnerHeight();
      let tableHeight = computed(()=>{
        return (innerHeight.value-100)
      });
      onMounted(()=>{
        console.log(tableHeight.value,'tableHeight');
      })
        return {
          tableHeight,
            thumbStyle: ref({
                right: '2px',
                borderRadius: '5px',
                backgroundColor: '#027be3',
                width: '0px',
                opacity: 0.75
            }),
            miniState: ref(false)
        }
    },

}
</script>
<template>
  <q-drawer v-model="getBaseMenu.status" show-if-above bordered class="bg-white" :width="154" >
<!--    <q-drawer v-model="getBaseMenu.status" show-if-above bordered class="bg-grey-3"-->
<!--    :width="240"-->
<!--    :breakpoint="500"-->
<!--    :mini="miniState"-->
<!--    mini-to-overlay-->
<!--    @mouseover="miniState = false"-->
<!--    @mouseout="miniState = true"-->
<!--    >-->
<!--    <q-item  class="text-grey-8" dense style="padding-top: 5px;padding-bottom: 5px;margin-left: 0px;padding-left: 35px" clickable v-ripple :class="currentPath==''?'menu-active':''" to="" >-->
<!--              <q-item-section avatar :style="setLevel"><q-icon name="fas fa-home"/></q-item-section>-->
<!--      <q-item-section><q-item-label class="text-weight-bold main-menu">首页</q-item-label></q-item-section>-->
<!--    </q-item>-->
        <q-scroll-area :style="{width:'100%',height:tableHeight+'px'}" :thumb-style="thumbStyle">
            <q-list padding class="text-grey-8">
                <div class="EDI__drawer-item" v-for="(menu, index) in getBaseMenu.menus" :key="index">
                    <menu-main :menu-list="menu" :init-level="miniState?0:0.4" :style="miniState?'margin-left:-12px':''"/>
<!--                  todo-->
<!--                    <q-separator inset class="q-my-sm" v-if="getBaseMenu.menus.length-1>index"/>-->
                </div>
            </q-list>
        </q-scroll-area>
    <div class="q-mt-lg q-mb-sm absolute-bottom text-center left-drawer-copyright" v-if="!miniState">
      <div class="copy-right text-grey-5">Copyright ©2022 FWCT Software Co., Ltd.</div>
    </div>
    </q-drawer>
</template>
<style lang="scss" scoped>
.left-drawer-copyright{
  font-size: 8px
}
::v-deep.q-drawer{
  z-index: 99999 !important;
}
</style>
